var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7891 7.19824C22.1224 8.81991 23.7324 11.3982 24.0591 14.3732",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07031 14.4318C4.37365 11.4685 5.96031 8.89017 8.27031 7.25684",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55078 24.4297C10.9041 25.118 12.4441 25.503 14.0658 25.503C15.6291 25.503 17.0991 25.153 18.4174 24.5114",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0715 8.98374C15.8627 8.98374 17.3148 7.53165 17.3148 5.7404C17.3148 3.94916 15.8627 2.49707 14.0715 2.49707C12.2802 2.49707 10.8281 3.94916 10.8281 5.7404C10.8281 7.53165 12.2802 8.98374 14.0715 8.98374Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63396 23.2396C7.4252 23.2396 8.87729 21.7875 8.87729 19.9963C8.87729 18.205 7.4252 16.7529 5.63396 16.7529C3.84271 16.7529 2.39062 18.205 2.39062 19.9963C2.39062 21.7875 3.84271 23.2396 5.63396 23.2396Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3644 23.2396C24.1557 23.2396 25.6078 21.7875 25.6078 19.9963C25.6078 18.205 24.1557 16.7529 22.3644 16.7529C20.5732 16.7529 19.1211 18.205 19.1211 19.9963C19.1211 21.7875 20.5732 23.2396 22.3644 23.2396Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.00f017d764b0fbaeded5527454fed3d9.svg";
export { ForwardRef as ReactComponent };